import { DOCS_ID } from "./constants";

export const styles = `

  .${DOCS_ID} #fabric-nav {
    display: none;
  }
  .${DOCS_ID} .gk-main-nav {
    display: none;
  }

  .${DOCS_ID} .drawer-links a {
    color: rgba(0, 0, 0, 0.6);
    text-decoration: none;
  }

  .${DOCS_ID} .drawer-links a li {
    cursor: pointer !important;
  }

  /* source: https://gist.github.com/dfrankland/f6fed3e3ccc42e3de482b324126f9542 */
  .${DOCS_ID} .bg-transparent {
    background-image: linear-gradient(
        45deg,
        #e6e6e6 25%,
        transparent 0,
        transparent 75%,
        #e6e6e6 0,
        #e6e6e6
      ),
      linear-gradient(
        45deg,
        #e6e6e6 25%,
        transparent 0,
        transparent 75%,
        #e6e6e6 0,
        #e6e6e6
      );
    background-position: 0 0, 10px 10px; /* Must be half of one side of the square */
    background-size: 20px 20px; /* Must be a square */
  }

  .${DOCS_ID} .text-pre-wrap {
    white-space: pre-wrap;
  }

  .${DOCS_ID} .deprecated {
    opacity: 0.5;
  }

  .${DOCS_ID} .overflow-auto {
    overflow: auto;
  }
`;
